module.exports = __webpack_public_path__ + "953f461ffa9f67f74dfec6d7558b092e.woff";